import VueTable from "@/v2/plugins/Table/VueTable.vue";

export default {
  install(Vue) {
    Vue.component('vue-table', VueTable);
  }
}
